<template>
<div class="chapter">
<div class="inner_page">
<h1><span class="caps">Starcarbon</span></h1>
<h3>A Meditation on Love</h3>
<h2>Ellen Gilchrist</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_title.vue?2889540e